import { TranslationObject } from '@ngx-translate/core';
import { Topic } from '@lib.core/entities/topic/topic';

export interface TopicDTO {
  id: number;
  nameid: string;
  title: TranslationObject;
  createdAt?: string;
  lastUpdatedAt?: string;
}

export function newTopicFromDto(topicDTO: TopicDTO | undefined): [Topic, Error | null] {
  if (topicDTO?.nameid === undefined || topicDTO?.title === undefined) {
    return [new Topic(0, '', {}, new Date()), new Error('no proper topic is provided')];
  }
  const createdAt = topicDTO.createdAt ? new Date(topicDTO.createdAt) : undefined;
  const lastUpdatedAt = topicDTO.lastUpdatedAt ? new Date(topicDTO.lastUpdatedAt) : undefined;
  return [new Topic(topicDTO.id, topicDTO.nameid, topicDTO.title, createdAt, lastUpdatedAt), null];
}

export function toTopicDTO(topic: Topic): TopicDTO {
  const { id, nameId, title, createdAt, lastUpdatedAt } = topic;
  return {
    id,
    nameid: nameId,
    title,
    createdAt: createdAt?.toISOString(),
    lastUpdatedAt: lastUpdatedAt?.toISOString(),
  }
}
